// convex/validators/brands.ts
import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";
import { customFieldValues } from "../../custom_fields";

export const validatorBrand = v.object({
	name: v.string(),
	description: v.optional(v.string()),
	logoId: v.optional(v.id("_storage")), // Logo de la marca
	website: v.optional(v.string()),
	country: v.optional(v.string()), // País de origen
	notes: v.optional(v.string()),
	internalControl,
	/** Valores de campos personalizados (Colecciones), por key de definición. */
	customFields: v.optional(customFieldValues),
});

export const brands = defineTable(validatorBrand)
	.index("by_company_id", ["internalControl.companyId"])
	.index("by_company_state", [
		"internalControl.companyId",
		"internalControl.state",
	])
	.index("by_name", ["internalControl.companyId", "name"])
	.index("by_search", [
		"internalControl.companyId",
		"name",
		"description",
		"country",
	]);
